<template>
  <div v-show="isOpen" :style="{ 'margin-top': margin + 'px' }" class="absolute right-0 bg-white top-0 mr-4 w-30 z-10 bg-opacity-75 p-2 text-sm">
    <template v-if="type == 'BUSSTOP'">
      <busstop />
    </template>
    <template v-else-if="type == 'POSITION'">
      <position />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Busstop from '../AiBus/Busstop'
import Position from '../AiBus/Position'

export default {
  components: {
    Busstop,
    Position
  },
  computed: {
    ...mapGetters({
      type: 'reservation/getType',
      height: 'map/getHeight'
    }),
    isOpen: function () {
      const d = this.$store.getters['drawer/getIsBusstopDetailOpen']
      const r = this.$store.getters['reservation/getIsReserving']
      return d && r
    },
    margin: function () {
      return (this.height / 2 - 50)
    }
  }
}
</script>
